import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';

// ---- COMMON MODULES ---- //
import { Functions } from './functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../providers/userdata-model'; 
import { DataExchanger } from '../providers/data-exchanger';
import { GameModel } from '../providers/game-model';
/*
  Generated class for the Login provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class Auth {
  errorMessage: string;
  errorMessages: string [] = new Array();
  serverurl: string;

  constructor(public playModel: GameModel, public functions: Functions, public translate: TranslateService, public userdataModel:UserdataModel, public http: Http, public dataExchanger:DataExchanger) {
    this.serverurl="http://xtribe.eu";
  }

  logout(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      this.getToken().then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('tokenGot')!=-1){
            var headers = new Headers();
            headers.append('Accept', 'application/json');
            headers.append('X-CSRF-Token', this.userdataModel.userdata[0].token);
            // To have this working, added code in xtribe ets_init
            headers.append('Authentication', this.userdataModel.userdata[0].session_name+"="+this.userdataModel.userdata[0].sessid);
            let options = new RequestOptions({ headers: headers });

            let postParams = {}
            
            this.http.post(this.serverurl+"/xtribe_api_2/user/logout", postParams, options)
              .subscribe(data => {
                //let obj = JSON.parse(data['_body']);
                this.userdataModel.clearUserdata();
                //TODO check if true
                resolve("LogoutIsOk");
              }, error => {
                console.log("error:"+error);// Error getting the data
                resolve(error);
                this.setErrorMessage("logout",error);
            });
          }else{
             resolve(responseString);
             this.setErrorMessage("logout",responseString);
          }
      });      
    });
  }

  register(username,password,email,fullname,sex,birthDate,education){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      //headers.append('Accept', 'application/json');
      headers.append('enctype', 'multipart/form-data');
      let options = new RequestOptions({ headers: headers });

      let formData:FormData = new FormData();
      formData.append("api-key", "1Xtribe.WebServ1");
      formData.append("name", username);
      formData.append("mail", email);
      formData.append("conf_mail", email);
      formData.append("pass", password);
      formData.append("I_agree", "1");
      formData.append("field_fullname[und][0][value]", fullname);
      formData.append("field_sex[und][0]", sex);
      formData.append("field_education[und][0]", education);
      formData.append("field_dob[und][0][value][date]", birthDate ); //"1980-11-04"
      
      this.http.post(this.serverurl+"/xtribe_api/user", formData, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.userdataModel.setUserdata(
            obj.guid,"","","","","","","","","","",
            "","","","","","",this.functions.emptyScore,this.functions.emptyLevel,this.functions.emptyCollectibles,this.functions.emptyBooksinfo,"","","");
          this.getUserDataFromXtribe();
          resolve("RegisterResIsOk");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("registration",error);
        });
    });
  }

  getUserDataFromXtribe(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('X-CSRF-Token', this.userdataModel.userdata[0].token);
      // To have this working, added code in xtribe ets_init
      headers.append('Authentication', this.userdataModel.userdata[0].session_name+"="+this.userdataModel.userdata[0].sessid);

      let options = new RequestOptions({ headers: headers });
      
      this.http.get(this.serverurl+"/xtribe_api_2/userdata", options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          obj=obj[0];
          /*console.log("userdataXTRIBE");
          console.log(obj);*/
          this.userdataModel.setUserdata(
            obj.guid,obj.username,obj.email,"",obj.fullname,
            obj.sex,obj.education,
            obj.birthDate,obj.picture,obj.creationDate,
            obj.language,obj.spokenLanguages,obj.roles,
            obj.lastAccess,obj.lastLogin,obj.link,
            obj.cancelLink,-1,-1,"","","","","").then((response)=>{
              resolve("UserDatasIsOk");
            });
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("userdata",error);
        });
    });
  }

  getToken(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('Authentication', this.userdataModel.userdata[0].session_name+"="+this.userdataModel.userdata[0].sessid);
      let options = new RequestOptions({ headers: headers });
     
      this.http.post(this.serverurl+"/xtribe_api_2/user/token", options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.userdataModel.setUserdata(
            "","","","","","","","","","",
            "","","","","","","",-1,this.functions.level,"","",obj.token,"","").then((response)=>{
              resolve("tokenGot");
            });  ;
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("gettoken",error);
        });
    });
  }

  /*getLoggedUser(){
    this.errorMessage="";
    this.errorMessages=[];
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('X-CSRF-Token', this.userdataModel.userdata[0].token);
      headers.append('Authentication', this.userdataModel.userdata[0].session_name+"="+this.userdataModel.userdata[0].sessid);
      let options = new RequestOptions({ headers: headers });

      this.http.post("http://xtribe.eu:8080/xtribe_api_2/system/connect", options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          resolve("tokenGot");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("gettoken",error);
        });
    });
  }*/

  login(username, password, automatic){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      //headers.append('X-CSRF-Token', this.userdataModel.userdata[0].token);
      //headers.append('Authentication', this.userdataModel.userdata[0].session_name+"="+this.userdataModel.userdata[0].sessid);
      let options = new RequestOptions({ headers: headers });

      let postParams = {
        "username" : username,
        "password" : password
      }
      
      this.http.post(this.serverurl+"/xtribe_api_2/user/login", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);

          /* --- These operations must be executed in sequence! That's why the promises chain... ---
            1) Login
            2) Clean storage game userdata (Score, level, booksinfo, collectibles) and gamedata (full games json)
            3) Initialize userdata qith empty values (score 0, level 1, bookmark and collectibles cleaned)
            4) Store in userdata login data and clean userdata
            5) Ask Xtribe for user profile data
            6) Store in userdata xtribe profile data
            7) Ask rubedo server for game userdata
            8) Store in userdata game userdata if available
            9) Store on server game userdata and user profile data (it can be the first time he joins!)
            9) Ask rubedo server for game data
            10) Store game data locally and in storage
          */
          this.playModel.clearGamesData().then((response)=>{
            this.userdataModel.clearUserdata().then((response)=>{
              var usergamedata=[];
              if(!obj.score){ usergamedata[0]=this.functions.emptyScore; }else{ usergamedata[0]=obj.score;}
              if(!obj.level){ usergamedata[1]=this.functions.emptyLevel; }else{ usergamedata[1]=obj.level;}
              if(!obj.collectibles){ usergamedata[2]=this.functions.emptyCollectibles; }else{ usergamedata[2]=obj.collectibles;}
              if(!obj.booksinfo){ usergamedata[3]=this.functions.emptyBooksinfo; }else{ usergamedata[3]=obj.booksinfo;}
              
              this.userdataModel.setUserdata(
                obj.guid,"","","","","","","","","","","","",
                "","","","",usergamedata[0],usergamedata[1],usergamedata[2],usergamedata[3],obj.token,obj.session_name,obj.sessid).then((response)=>{
                  this.getUserDataFromXtribe().then((response)=>{
                    this.dataExchanger.getUserGameDataFromServer().then((response)=>{
                      /*console.log("USERGAMEDATA");
                      console.log(this.userdataModel.userdata);*/
                      this.dataExchanger.storeUserDataOnServer().then((response)=>{
                        this.dataExchanger.storeUserGamedataOnServer();
                      });
                      
                      this.dataExchanger.getGamesDataFromServer().then((response)=>{
                        resolve("loginResIsOk");
                      });
                    });
                  });
              });
            });
          });
          //this.playModel.getInitialGamesDataFromStorage();
          
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("registration",error);
        });
    });
  }

  //TODO edit profile
  editProfile(username,password,email,fullname,sex,birthDate,education){
    this.errorMessage="";
    return new Promise((resolve) =>{
      if(!this.functions.deviceIsOnline()){
        this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
        resolve("noConnection");
        return;
      }

      var headers = new Headers();
      headers.append('Accept', 'application/json');
      headers.append('Authentication', this.userdataModel.userdata[0].session_name+"="+this.userdataModel.userdata[0].sessid);
      let options = new RequestOptions({ headers: headers });

      let postParams = {
        "username" : username,
        "password" : password
      }
      
      this.http.post(this.serverurl+"/xtribe_api_2/user/login", postParams, options)
        .subscribe(data => {
          let obj = JSON.parse(data['_body']);
          this.userdataModel.setUserdata(obj.guid,"","","","","","","","","","","","","","","","",-1,this.functions.level,"","",obj.token,obj.session_name,obj.sessid);
          this.getUserDataFromXtribe();
          resolve("EditProfileIsOk");
        }, error => {
          //console.log("error:"+error);// Error getting the data
          resolve(error);
          this.setErrorMessage("registration",error);
      });
    });
  }

  //TODO sistemare per messaggi d'errore multipli
  setErrorMessage(callType, error){
    //TODO sistemare error messages
    /*this.errorMessages.push("yea");
    this.errorMessages.push("yea2");
    console.log(this.errorMessages);*/
    var responseString:string;
    this.errorMessage="";
    responseString=error.toString();
    //console.log(responseString);
    if(callType=="registration"){
      if(responseString.indexOf('Wrong username or password')!=-1){
        this.translate.get('userPwdWrong').subscribe(value => { this.errorMessage += value;});
      }
      if(responseString.indexOf('is already taken')!=-1){
        this.translate.get('nameTaken').subscribe(value => { this.errorMessage += value;});
      }
      if(responseString.indexOf('is already registered')!=-1){
        this.translate.get('emailTaken').subscribe(value => { this.errorMessage += value;});
      }
      if(this.errorMessage!=""){
        return;
      }
      
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
    if(callType=="login"){
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
    if(callType=="logout"){
      if(responseString.indexOf('User is not logged in')!=-1){
        this.translate.get('userNotLoggedIn').subscribe(value => { this.errorMessage += value;});
        return;
      }
      if(responseString.indexOf('CSRF validation failed')!=-1){
        this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage += value;});
        return;
      }
    
      this.translate.get('genericErrorMessage').subscribe(value => { this.errorMessage = value;});
      return;
    }
  }
}

/*
[
    {
        "username": "efalivene_plr",
        "email": "e.falivene@ilabroma.com",
        "fullname": "Prova betta",
        "picture": "  <div class=\"user-picture\">\n    <a href=\"/it/users/efaliveneplr\" title=\"Visualizza profilo utente.\"><img typeof=\"foaf:Image\" src=\"http://xtribe.eu:8080/sites/default/files/styles/avatar/public/pictures/picture-16166-1500303787.jpg?itok=sihg_bwk\" width=\"64\" height=\"64\" alt=\"Ritratto di efalivene_plr\" title=\"Ritratto di efalivene_plr\" /></a>  </div>\n",
        "birthDate": {
            "value": "1999-08-12 00:00:00",
            "timezone": "Europe/Rome",
            "timezone_db": "Europe/Rome",
            "date_type": "datetime"
        },
        "sex": "F",
        "creationDate": "2016-10-21 02:00",
        "education": "Primaria",
        "language": "Italian",
        "spokenLanguages": [
            "Italian"
        ],
        "roles": null,
        "lastAccess": "Lunedì, Luglio 17, 2017 - 16:54",
        "lastLogin": "Lunedì, Luglio 17, 2017 - 16:54",
        "link": "<a href=\"/it/users/efaliveneplr\">mostra</a>",
        "cancelLink": "<a href=\"/it/user/16166/cancel?destination=xtribe_api_2/userdata\">annulla</a>",
        "guid": "b38fbe53c5cb1",
        "uid": "16166"
    }
]
*/


// WEBPACK FOOTER //
// ./src/providers/auth.ts